interface InfoTooltipProps {
  /** The tooltip text to display */
  text: string;
  /** Width class for the tooltip (default: 'w-56') */
  width?: string;
}

/**
 * Info icon with hover tooltip
 */
export function InfoTooltip({ text, width = 'w-56' }: InfoTooltipProps) {
  return (
    <div className="group relative">
      <svg
        className="w-4 h-4 text-gray-400 cursor-help"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <div
        className={`absolute left-0 bottom-full mb-2 hidden group-hover:block ${width} p-2.5 bg-white text-gray-700 text-xs rounded-lg shadow-lg border border-gray-200 z-10`}
      >
        {text}
        <div className="absolute left-3 top-full w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-white" />
        <div className="absolute left-3 top-full mt-px w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-gray-200 -z-10" />
      </div>
    </div>
  );
}
